import React from 'react'
import "./SocialIconGroup.css"
const SocialIconsGroup = () => {
  
  return (
    <span className='d-flex justify-content-center align-items-center social_icon_container'>
      {/* <i class="fa-brands fa-youtube yt"></i> */}
      <i class="fa-brands fa-instagram ig"></i>
<i class="fa-brands fa-facebook fb"></i>

<i class="fa-brands fa-whatsapp whatsapp"></i>
<i class="fa-brands fa-pinterest-p pintrest"></i>
    </span>
  )
}

export default SocialIconsGroup